module.exports = __webpack_public_path__ + "img/1000Blocks-STAGE-03.4db0d2ee.png";